<script>
import Loader from "@/components/widgets/loader";

export default {
  components: {
    Loader,
  },
  data() {
    const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
    return {
      todays_date: today_str,
    };
  },
  props: {
    updating: {
      type: Boolean,
    },
    tasks: {
      type: Array,
          default: () => {
          return []
      },
    },
  },
};
</script>
<template>
  <Loader :loading="updating">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title mb-5">Today's Tasks</h4>
        <ul class="verti-timeline list-unstyled" v-if="tasks.length">

          <li class="event-list" v-for="task in tasks" :key="task.id">
            <div class="event-timeline-dot">
              <i class="bx bx-right-arrow-circle font-size-18"></i>
            </div>
            <div class="media">
              <div class="me-3">
                <h5 class="font-size-14">
                  {{task.vehicle_number}}
                  <i
                    class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
                  ></i>
                </h5>
              </div>
              <div class="media-body">
                <div>
                  <p v-if="task.insurance_followup==todays_date">Insurance</p>
                  <p v-if="task.fitness_followup==todays_date">Fitness</p>
                  <p v-if="task.tax_followup==todays_date">Tax</p>
                  <p v-if="task.permit_followup==todays_date">Permit</p>
                  <p v-if="task.registration_followup==todays_date">Registration</p>
                  <p v-if="task.welfare_fund_followup==todays_date">Welfare Fund</p>
                </div>
              </div>
            </div>
          </li>
          
          <!-- <li class="event-list active">
            <div class="event-timeline-dot">
              <i
                class="bx bxs-right-arrow-circle font-size-18 bx-fade-right"
              ></i>
            </div>
            <div class="media">
              <div class="me-3">
                <h5 class="font-size-14">
                  15 Nov
                  <i
                    class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
                  ></i>
                </h5>
              </div>
              <div class="media-body">
                <div>Pellentesque ullamcorper nisi eu molestie posuere</div>
              </div>
            </div>
          </li> -->
          
        </ul>
        <p v-else>No tasks for today</p>
        <div class="mt-4">         
          <router-link :to="{ name: 'followups'}" class="btn btn-primary btn-sm">View More <i class="mdi mdi-arrow-right ms-1"></i></router-link>
        </div>
      </div>
    </div>
  </Loader>
</template>